import editPage from './view/edit.html'
import saveResultPage from './view/saveResult.html'

class SmartgoodsListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, dictService, querySort, initSortService) {
        dictService.get('yes_no_flag')
        // 已选择的数据 eg:[id1, id2]
        $scope.selectedArr = []
        $scope.reset = function () {
            $scope.queryParam = {
                isSmartCoding: '0', // -1-未保存，0-未智能匹配，1-全量匹配
                goodsName: '',
            }
        }
        $scope.reset()
        // 是否有脏数据，编辑，删除后还未保存
        $scope.dirty = false

        // 表头排序
        $scope.copyresData = []
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function () {
            if ($scope.copyresData && !$scope.copyresData.length) return
            const list = JSON.parse(JSON.stringify($scope.copyresData))
            const { sortKey } = $scope.orderMap
            let type = 'string'
            if (sortKey == 'taxCode' || sortKey == 'taxRate') {
                type = 'num'
            }
            const flag = $scope.orderMap.sortVal == 'desc' ? 1 : -1
            if ($scope.orderMap.sortVal) {
                list.sort((a, b) => {
                    if (!a[sortKey]) return
                    return querySort.compareFun(a[sortKey], b[sortKey], type) * flag
                })
            }
            $scope.resData = list
        }
        function queryGoodsInfo() {
            httpRequest.get_qrySmartGoodsInfo($scope.queryParam).then((res) => {
                $scope.resData = res.data.value
                $scope.selectedArr = []
                $scope.dirty = false
                $scope.copyresData = res.data.value.length > 0 ? JSON.parse(JSON.stringify($scope.resData)) : []
                $scope.selectedHandle()
            })
        }
        function queryImportResult() {
            httpRequest.get_qrySmartGoodsInfo({
                isSmartCoding: '-1',
                goodsName: '',
            }).then((res) => {
                $scope.resData = res.data.value
                $scope.copyresData = res.data.value.length > 0 ? JSON.parse(JSON.stringify($scope.resData)) : []
                $scope.selectedHandle()
                $scope.dirty = $scope.resData.length > 0
                $scope.selectedArr = []
            })
        }
        $scope.checkCodes = function checkCodes() {
            httpRequest.post_checkTaxCode($scope.resData).then((res) => {
                $scope.dirty = true
                $scope.resData = res.data.value
                $scope.copyresData = res.data.value.length > 0 ? JSON.parse(JSON.stringify($scope.resData)) : []
            })
        }
        function openSaveResultDialog(result) {
            $uibModal.open({
                template: saveResultPage,
                controller: ['$scope', '$uibModalInstance', (scope, uibModalInstance) => {
                    scope.result = result
                    scope.cancel = function cancel() {
                        uibModalInstance.dismiss()
                    }
                }],
                openedClass: 'mod-modal mod-modal-hg',
                backdrop: 'static',
            })
        }
        $scope.saveCodes = function saveCodes() {
            return httpRequest.post_saveSmartGoodsInfo($scope.resData).then((res) => {
                // 保存成功即清空
                $scope.resData = []
                $scope.copyresData = []
                const result = res.data.value
                $scope.dirty = false
                if (result.duplicate.length !== 0) {
                    openSaveResultDialog(result)
                } else if (!result.errorCount) {
                    logger.logSuccess('保存成功')
                } else {
                    logger.logMsg({
                        title: '操作结果',
                        icon: 1,
                        message: `共计${$scope.resData.length}种商品,成功${result.successCount}张，失败${result.errorCount}张！`,
                    })
                }
            })
        }
        // 删除多个确认弹窗
        $scope.delGoods = function delGoods(id) {
            const selectedArr = id ? [id] : $scope.selectedArr
            if (selectedArr.length > 0) {
                const msg = selectedArr.length > 1 ? '确认删除这些商品信息?' : '确认删除此商品信息?'
                sweetalert.confirm('删除提醒', msg).then(() => {
                    httpRequest.post_delSmartGoodsInfo(selectedArr).then(() => {
                        $scope.dirty = true
                        selectedArr.forEach((id1) => {
                            $scope.resData.forEach((item, index) => {
                                if (item.goodsId === id1) {
                                    $scope.resData.splice(index, 1)
                                }
                            })
                            $scope.copyresData.forEach((item, index) => {
                                if (item.goodsId === id1) {
                                    $scope.copyresData.splice(index, 1)
                                }
                            })
                        })
                        if (!id) {
                            $scope.selectedArr = []
                        }
                    })
                })
            } else {
                logger.logError('请先选择商品')
            }
        }
        $scope.tableDropdownConfig = [{
            label: '编辑',
            handler(item) {
                if (!item.taxMergeName) {
                    logger.logError('请先选择该商品的税收分类编码')
                    return
                }
                $uibModal.open({
                    template: editPage,
                    controller: 'smartGoodsEditCtrl',
                    openedClass: 'mod-modal mod-modal-lg',
                    backdrop: 'static',
                    resolve: {
                        smartGoods() {
                            return item
                        },
                    },
                }).result.then((newItem) => {
                    $scope.dirty = true
                    Object.assign(item, newItem)
                })
            },
            showWhile() {
                return true
            },
        }, {
            label: '删除',
            handler(item) {
                $scope.delGoods(item.goodsId)
            },
            showWhile() {
                return true
            },
        }]
        // 导入
        // 导入配置
        $scope.importconfig = {
            code: 'SMART_GOODS_INFO',
            msg: '正在进行税分编码匹配，请耐心等待',
            appName: host.etcloudOvat,
            url: 'dlTaskService/import_SMART_GOODS_INFO',
            downloadAppName: host.etcloudOvat,
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            callback() {
                queryImportResult()
            },
        }

        // 返回数据
        $scope.resData = []
        // 税率数组
        httpRequest.get_queryGoodsTax({
            taxMergeCode: -1,
            invType: -1,
        }).then((res) => {
            $scope.taxRateList = res.data.value
        })

        // 分页参数
        $scope.pageGoodsInfoOpt = {
            totalItems: 10, // 组件初始化设置总页数
            currentPage: 1, // 设置显示第一页
            maxSize: 10, // 每一叶显示记录数
        }
        $scope.qryTaxClassInfo = function qryTaxClassInfo($item, item) {
            // 选择的是同一个税分编码
            if (item.taxMergeCode === $item.mergeCode && item.taxCode === $item.taxCode) {
                return
            }
            item.taxMergeCode = $item.mergeCode
            item.taxCode = $item.taxCode
            item.codeVersions = $item.codeVersions
            item.taxMergeName = $item.taxName
            item.taxRate = $item.taxRateList[0]
            if ($item.discountOptionList && $item.discountOptionList.length < 2) {
                item.isPrivilege = 1
                // if ($item.taxSpecialManageList.join('').indexOf(item.privilegeType) < 0) {
                item.privilegeType = $item.taxSpecialManageList[0]
                // 获取税率取税率数组第一个
                const rateReq = {
                    taxMergeCode: item.taxMergeCode,
                    privilegeType: encodeURIComponent(item.privilegeType),
                }
                httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => {
                    item.taxRate = res.data.value[0]
                })
                // }
            }
        }
        // 加载获取数据
        // queryGoodsInfo()
        $scope.search = function search() {
            if ($scope.dirty) {
                sweetalert.confirm('操作提醒', '你的操作过的数据还未保存，查询后会被清除，是否需要先保存？').then(() => {
                    $scope.saveCodes().then(queryGoodsInfo)
                }, queryGoodsInfo)
            } else {
                queryGoodsInfo()
            }
        }

        $scope.revert = function revert(item) {
            httpRequest.get_qrySmartGoodsInfoById({
                goodsId: item.goodsId,
            }).then((res) => {
                Object.assign(item, res.data.value)
            })
        }
    }
}
SmartgoodsListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'dictService', 'querySort', 'initSortService']
export default SmartgoodsListCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/smartGoods/SmartGoodsListCtrl.js